module.exports = __webpack_public_path__ + "img/JunNishimura_企画書_ページ_12.34debb6d.jpg";